module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-421.a72d0ae.woff2";